<template>
    <div v-if="marcacao && marcacao.docs && marcacao.docs.length">
        <div class="mb-2 text-right" v-if="tipo_assinatura_lote()">
            <a href="#" class="card-link" @click.prevent="assinar_multiplos()">
                Assinar múltiplos
            </a>
        </div>

        <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(doc, idx) in marcacao.docs" :key="idx">
                <a href="#" @click.prevent="imprimir(doc)">{{ doc.st_nome }}</a>

                <div>
                    <template v-if="tem_redirect(doc.st_serv_imp)">
                        Impressão
                    </template>

                    <template v-else>
                        <a href="#" @click.prevent="imprimir(doc, doc.st_serv_imp)" class="card-link">
                            {{ doc.st_serv_imp }}
                        </a>
                    </template>

                    <div class="spinner-border spinner-border-sm ml-4 text-secondary" role="status" v-if="loading && id_loading === doc.id_modelo_documento">
                        <span class="sr-only">Loading...</span>
                    </div>

                    <a :href="tem_anexo_tipo(doc)" title="Documento Anexado" class="card-link ml-4" v-if="false && tem_anexo_tipo(doc)" target="_blank">
                        <i class="fa fa-paperclip" aria-hidden="true"></i>
                    </a>

                    <a href="#" title="Assinar Documento" class="card-link ml-4" @click.prevent="enviar_documento_por_email(doc, true)" v-if="doc.fl_ipsign || doc.fl_zerodox">
                        <i class="fa-solid fa-signature fa-fw"></i>
                    </a>

                    <a href="#" title="Compartilhar documento com o paciente" class="card-link ml-4" @click.prevent="enviar_documento_por_email(doc, false, true)" v-if="doc.compartilhar_whatsapp">
                        <i class="fa-brands fa-whatsapp"></i>
                    </a>

                    <a href="#" title="Enviar por e-mail" class="card-link ml-4" @click.prevent="enviar_documento_por_email(doc)">
                        <i class="far fa-envelope-open fa-fw"></i>
                    </a>
                </div>
            </li>
        </ul>

        <DocumentoIPSign
            ref="documentoIPSignRef"
            :model_id="marcacao ? marcacao.id_marcacao : null"
            model_type="marcacao"
            :id_modelo_documento="id_modelo_documento"
        />

        <DocumentoZerodox
            ref="documentoZerodoxRef"
            :model_id="marcacao ? marcacao.id_marcacao : null"
            model_type="marcacao"
        />

    </div>
</template>

<script>
import _ from 'lodash';
import DocumentoIPSign from "../../shared/DocumentoIPSign.vue";
import DocumentoZerodox from "../../shared/DocumentoZerodox.vue";

export default {
    data() { 
        return { 
            loading: false, 
            id_loading: null, 
            id_modelo_documento: null,
        };
    },

    components: {
        DocumentoIPSign,
        DocumentoZerodox,
    },

    props: ['marcacao', 'id_pagamento_atendimento'],

    methods: { 
        tem_anexo_tipo (doc) { 
            if ( !doc.id_tipo_arquivo ) { 
                return false;
            } 
            
            if ( this.marcacao && this.marcacao.arquivos && this.marcacao.arquivos.length ) { 
                let teste = this.marcacao.arquivos.find( a => a.arquivo && a.arquivo.id_tipo_arquivo == doc.id_tipo_arquivo );
                
                if ( teste ) { 
                    return teste.arquivo.temporary_url;
                } 
            }

            return false; 
        },

        tem_redirect (servimp) { 
            return ( servimp && ( servimp.indexOf('{si}') >= 0 || servimp.indexOf('{sis}') >= 0 ) ) ? true : false;
        },

        imprimir (doc, servimp = null) { 

            if ( !servimp && doc.st_serv_imp && doc.st_serv_imp.slice(0,3) == 'nf:' ) { 
                servimp = doc.st_serv_imp;
            }

            if ( servimp && servimp.indexOf('{si}') >= 0 ) { 

                let servidor = this.$util.getCookie('lab_servidor_impressao');

                if ( servidor ) { 
                    servimp = servimp.replace('{si}', servidor);
                }

            } else if ( servimp && servimp.indexOf('{sis}') >= 0 ) { 

                let servidor = this.$util.getCookie('sis');

                if ( servidor ) { 
                    servimp = servimp.replace('{sis}', servidor);
                }

            }

            this.$util.print_preview(
                'imprimir/documento_recepcao/?si=' + ( servimp ? 1 : 0), //  + '&servimp=' + encodeURIComponent(servimp), 
                false, 
                { 
                    ...doc,
                    id_marcacao: this.marcacao.id_marcacao, 
                    refresh: true, 
                    servimp: servimp, 
                    pa_id: this.id_pagamento_atendimento
                }
            );
        },

        enviar_documento_por_email (doc, assinar = false, whatsapp = false) {

            if ( this.loading ) { 
                this.$toast.add({
                    severity: 'info',
                    summary: 'Atenção',
                    detail: 'Em andamento...',
                    life: 5000
                });
                return; 
            }
            
            if ( !this.marcacao ) {
                
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Marcação não encontrada.',
                    life: 5000
                });

                return;
            }

            if (!assinar && !whatsapp && !confirm("Confirma o envio do documento '" + doc.st_nome + "' por e-mail para o paciente?") )
                return; 

            if(!assinar && whatsapp && !confirm("Confirma o envio do documento '" + doc.st_nome + "' por WhatsApp para o paciente?") )
                return;

            this.loading = true;
            this.id_loading = doc.id_modelo_documento;

            this.axios.post('/imprimir/documento_recepcao', {
                ...doc,
                id_marcacao: this.marcacao.id_marcacao,
                pa_id: this.id_pagamento_atendimento,
                fl_enviar_email: !whatsapp,
                fl_enviar_whatsapp: whatsapp,
                refresh: true, 
                assinar: assinar,
            }).then(response => {

                if(!assinar) {
                    this.$toast.add({
                        severity: response.data.status_code == 200 ? 'success' : 'error',
                        summary: response.data.status_code == 200 ? 'Sucesso' : 'Erro',
                        detail: response.data.msg ? response.data.msg : 'Erro ao enviar e-mail.',
                        life: 5000
                    });
                } else {
                    response = response.data;

                    if(response && response.pdf) {
                        const nome = _.get(this.marcacao, 'paciente.st_nome', _.get(this.marcacao, 'cadastro_temporario.st_nome'));
                        const cpf = _.get(this.marcacao, 'paciente.cadastro.st_cpf', _.get(this.marcacao, 'cadastro_temporario.st_cpf'));
                        const email = _.get(this.marcacao, 'paciente.cadastro.st_email', _.get(this.marcacao, 'cadastro_temporario.st_email'));
                        const dt_nascimento = _.get(this.marcacao, 'paciente.cadastro.dt_nascimento', _.get(this.marcacao, 'cadastro_temporario.dt_nascimento'));

                        let unidade = _.get( this.marcacao, "unidade_operacao.st_nome");
                        let operadora = _.get( this.marcacao, "plano.search");

                        // quantidade de ocorrencias da tag de assinatura
                        var qtdOcorrenciasAss = 0;
                        // if (this.documento && this.documento.st_chave_assinatura_ipsign) {
                        //     var substrings = this.documento.st_descricao.split(this.documento.st_chave_assinatura_ipsign);
                        //     if (substrings && substrings.length > 0) {
                        //         qtdOcorrenciasAss = substrings.length - 1;
                        //     }
                        // }

                        if (response.zerodox) {
                            this.$refs.documentoZerodoxRef.show(
                                response.pdf,
                                doc.st_nome,
                                email,
                                cpf,
                                nome,
                                unidade,
                                operadora,
                                dt_nascimento,
                                null,
                                null, 
                                null, 
                                doc.id_modelo_documento
                            );
                        } else if ( response.ipsign ) {
                            this.id_modelo_documento = doc.id_modelo_documento;

                            this.$nextTick(() => {
                                // IPSIGN
                                this.$refs.documentoIPSignRef.show(
                                    response.pdf,
                                    doc.st_nome,
                                    email,
                                    cpf,
                                    nome,
                                    unidade,
                                    operadora,
                                    'ASS:', // TODO: verificar com André - this.documento.st_chave_assinatura_ipsign,
                                    qtdOcorrenciasAss,
                                    dt_nascimento,
                                    // m_id,
                                    // m_type,
                                    // this.atendimento ? this.atendimento.id_atendimento : null
                                );
                            });
                            
                        } else {

                            console.log(response);

                            this.$toast.add({
                                severity: 'error',
                                summary: 'Erro',
                                detail: 'Nenhum método de assinatura disponível para este documento.',
                                life: 5000
                            });

                        }


                    }
                }

            })
            .finally(() => { 
                this.loading = false;
                this.id_loading = null; 
            });

        },

        qtd_docs_assinaveis (tipo = null) {
            if (!this.marcacao || !this.marcacao.docs || !this.marcacao.docs.length) {
                return 0;
            }

            if (tipo == 'ipsign') {
                return this.marcacao.docs.filter(doc => doc.fl_ipsign).length;
            }

            if (tipo == 'zerodox') {
                return this.marcacao.docs.filter(doc => doc.fl_zerodox).length;
            }

            return this.marcacao.docs.filter(doc => doc.fl_ipsign || doc.fl_zerodox).length;
        },

        tipo_assinatura_lote () {
            if (!this.marcacao || !this.marcacao.docs || !this.marcacao.docs.length) {
                return null;
            }

            const primeiroDocAssinavel = this.marcacao.docs.find(doc => doc.fl_ipsign || doc.fl_zerodox);

            if (!primeiroDocAssinavel) {
                return null;
            }

            return primeiroDocAssinavel.fl_ipsign ? 'ipsign' : 'zerodox';
        },

        assinar_multiplos () {
            const tipo = this.tipo_assinatura_lote();

            if (!tipo) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum documento disponível para assinatura em lote.',
                    life: 5000
                });
                return;
            }

            if ( this.loading ) {
                this.$toast.add({
                    severity: 'info',
                    summary: 'Atenção',
                    detail: 'Em andamento...',
                    life: 5000
                });
                return;
            }

            if ( !this.marcacao || !this.marcacao.id_marcacao ) {
                this.$toast.add({
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Marcação não encontrada.',
                    life: 5000
                });
                return;
            }

            const docs = (this.marcacao.docs || []).filter(doc => {
                return tipo == 'ipsign' ? doc.fl_ipsign : doc.fl_zerodox;
            });

            if (!docs.length) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Atenção',
                    detail: 'Nenhum documento disponível para assinatura em lote.',
                    life: 5000
                });
                return;
            }

            const nome = _.get(this.marcacao, 'paciente.st_nome', _.get(this.marcacao, 'cadastro_temporario.st_nome'));
            const cpf = _.get(this.marcacao, 'paciente.cadastro.st_cpf', _.get(this.marcacao, 'cadastro_temporario.st_cpf'));
            const email = _.get(this.marcacao, 'paciente.cadastro.st_email', _.get(this.marcacao, 'cadastro_temporario.st_email'));
            const dt_nascimento = _.get(this.marcacao, 'paciente.cadastro.dt_nascimento', _.get(this.marcacao, 'cadastro_temporario.dt_nascimento'));
            const unidade = _.get(this.marcacao, 'unidade_operacao.st_nome');
            const operadora = _.get(this.marcacao, 'plano.search');

            console.log('ass mult', tipo);

            if (tipo == 'ipsign') {
                this.id_modelo_documento = docs[0].id_modelo_documento;

                this.$nextTick(() => {
                    this.$refs.documentoIPSignRef.show_batch({
                        docs,
                        email,
                        cpf,
                        nome,
                        unidade,
                        operadora,
                        dt_nascimento,
                        id_marcacao: this.marcacao.id_marcacao,
                        pa_id: this.id_pagamento_atendimento,
                    });
                });

                return;
            }

            this.$refs.documentoZerodoxRef.show_batch({
                docs,
                email,
                cpf,
                nome,
                unidade,
                operadora,
                dt_nascimento,
                id_marcacao: this.marcacao.id_marcacao,
                pa_id: this.id_pagamento_atendimento,
            });
        },
    }
}
</script>
